import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * Slot recipe for the header account CTA.
 *
 * - `badge` is the logged-in status indicator: a small pine-green dot with a
 *   white ring pinned to the bottom-right of the user icon, rendered only for a
 *   registered customer (per Figma node 35241:54594).
 *
 * The round icon-button chrome (36×36, hover, focus-ring) is owned by
 * `header-icon-button` (STOK-17031 Step 10), which this CTA renders through;
 * this recipe only covers the badge (dot) positioning.
 */
export const accountCtaRecipe = defineSlotRecipe({
    slots: ['badge'],
    base: {
        badge: {
            position: 'absolute',
            bottom: 'spacing-7',
            right: 'spacing-7',
            width: 'spacing-8',
            height: 'spacing-8',
            borderRadius: 'full',
            border: 'sm',
            borderColor: 'primary.base.white',
            bg: 'secondary.pineGreen',
            pointerEvents: 'none'
        }
    }
})
